import { Form, FormField } from "common/Forms";
import { TableRenderer } from "common/Table";
import { Checkbox } from "common/Forms/inputs";
import sortAsc from "assets/img/sort-asc.svg";
import sortDesc from "assets/img/sort-desc.svg";

export const TableView = ({
  list,
  bulkProductTargetSelectorIds,
  setBulkProductTargetSelectorIds,
  sorting,
  onSortChange,
}) => {
  const isSelected = (selectedProductId) =>
    selectedProductId && bulkProductTargetSelectorIds?.productIds.length
      ? bulkProductTargetSelectorIds.productIds.some((x) => x.id === selectedProductId)
      : false;

  const onBulkProductsTargetIdsHandler = (selectedProductId) => {
    if (setBulkProductTargetSelectorIds && bulkProductTargetSelectorIds && selectedProductId) {
      if (!isSelected(selectedProductId) && bulkProductTargetSelectorIds.productIds.length >= 30) {
        return; // Prevent adding more than 30 IDs
      }
      isSelected(selectedProductId)
        ? setBulkProductTargetSelectorIds({
            productIds: bulkProductTargetSelectorIds.productIds.filter(
              (x) => x.id !== selectedProductId,
            ),
          })
        : setBulkProductTargetSelectorIds({
            productIds: [...bulkProductTargetSelectorIds.productIds, { id: selectedProductId }],
          });
    }
  };

  return (
    <Form>
      <TableRenderer
        data={list ?? []}
        columns={[
          {
            name: "Action",
            bodyRenderer: (x) => (
              <FormField
                id={`${x._id}-target-selector`}
                inputFactory={(id, name, onValidation) => (
                  <Checkbox
                    id={id}
                    name={name}
                    onValidation={onValidation}
                    value={isSelected(x._id)}
                    onChange={(n) => onBulkProductsTargetIdsHandler(x._id)}
                  />
                )}
              />
            ),
          },
          {
            name: "Product Image",
            widthRequest: { min: 140 },
            bodyRenderer: (x) => (
              <img
                src={x.productImage}
                alt="prodImg"
                height={50}
                width={50}
                style={{ borderRadius: "5px" }}
              />
            ),
          },
          {
            name: "Product Name",
            widthRequest: { min: 200 },
            headerRenderer: () => {
              const isAscActive = sorting?.sortBy === 1 && sorting?.sortOrder === 1;
              const isDescActive = sorting?.sortBy === 1 && sorting?.sortOrder === 2;
              return (
                <div className="flex items-center justify-between w-full">
                  <span>Product Name</span>
                  <div className="flex items-center gap-1">
                    <img
                      src={sortAsc}
                      alt="sort asc"
                      onClick={() => onSortChange?.(1, 1)}
                      className={`cursor-pointer transition-opacity hover:opacity-100 ${isAscActive ? "opacity-100" : "opacity-35"}`}
                      style={{ width: 20, height: 20 }}
                    />
                    <img
                      src={sortDesc}
                      alt="sort desc"
                      onClick={() => onSortChange?.(1, 2)}
                      className={`cursor-pointer transition-opacity hover:opacity-100 ${isDescActive ? "opacity-100" : "opacity-35"}`}
                      style={{ width: 20, height: 20 }}
                    />
                  </div>
                </div>
              );
            },
            bodyRenderer: (x) => x?.productName ?? "-",
          },
          {
            name: "Product Price",
            widthRequest: { min: 140 },
            bodyRenderer: (x) => `${parseFloat(x?.price).toFixed(2) ?? "-"}`,
          },
          {
            name: "Site ID",
            bodyRenderer: (x) => x?.siteid ?? "-",
          },
          {
            name: "Product Description",
            bodyRenderer: (x) => x?.description ?? "-",
          },
        ]}
      />
    </Form>
  );
};
